/**
 * flashcards — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const flashcardsPack: ToilePack = {
    slug: 'flashcards',
    category: 'flashcards',
    name: 'Flashcards',
    tagline: tagline('cards', 'sets', 'styles'),
    chips: chips('sets', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'alphabet', label: 'Alphabet animals', subject: 'a big friendly bear, the letter and word beside it'},
        {key: 'counting', label: 'Counting', subject: 'five red apples in a row, the numeral beside them'},
        {key: 'shapes', label: 'Shapes', subject: 'one large triangle, the shape name beneath'},
    ],
    styles: [
        {key: 'flat', label: 'Flat bold', style: 'thick even outlines, simple geometric shapes', palette: 'solid primary colors on white', framing: 'one rounded card, subject centered'},
        {key: 'watercolor', label: 'Watercolor', style: 'gentle transparent washes with pooling edges', palette: 'warm hand-painted, cream paper', framing: 'one rounded card, subject centered'},
        {key: 'chalk', label: 'Chalkboard', style: 'white and pastel chalk strokes, faint smudging', palette: 'dusty chalk on slate green', framing: 'one rounded card, subject centered'},
    ],
    directions: ['for colors instead', 'with the word in French', 'simpler, for a toddler'],
}
